<app-centre-small-opener>
    <h2 mat-dialog-title dialogTitle>Track Attendee</h2>
    <div contentContainer>
        <div *ngIf = "showTrackAttendeeEditForm == false">
            <button mat-icon-button (click) = "showTrackAttendeeForm(true)"><mat-icon>add</mat-icon></button>
        </div>
        <div class="col-md-12 d-flex flex-wrap" *ngIf = "showTrackAttendeeEditForm">
                <div class="col-md">
                    <mat-form-field class="attendee">
                        <mat-label>Attendee</mat-label>
                        <input matInput  [formControl]="addAttendee" readonly>
                    </mat-form-field>    
                </div>
                <div class="col-md">
                    <mat-form-field class="agenda">
                        <mat-label>Agenda</mat-label>
                        <mat-select disableOptionCentering panelClass="common-drop-down-class" [formControl]="agendaSelection">
                            <mat-option *ngFor="let m of agendaList" [value]="m.agendaTitle">{{m.agendaTitle}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md">
                    <mat-form-field class="attendee">
                        <mat-label>Time</mat-label>
                        <input matInput mask="Hh:m0:s0" placeholder="00:00:00" [dropSpecialCharacters]="false" [formControl]="time">
                    </mat-form-field>    
                </div>
                <div class="col-md">
                    <mat-form-field class="agenda">
                        <mat-label>Type</mat-label>
                        <mat-select disableOptionCentering panelClass="common-drop-down-class" [formControl]="typeSelection">
                            <mat-option value = "IN">IN</mat-option>
                            <mat-option value = "OUT">OUT</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md">
                    <mat-form-field class="attendee">
                        <mat-label>Reason</mat-label>
                        <textarea matInput [ngStyle]="{'height':'23px'}" [formControl] ="reason"></textarea>
                    </mat-form-field>
                </div>
                <div class="col-md" [ngStyle]="{'display':'flex', 'align-items':'center'}">
                    <button mat-icon-button *ngIf="typeSelection.value" (click) = "addToAttendeeTraker();hideTrackAttendeeForm(false)"><mat-icon>save</mat-icon></button>
                    <button mat-icon-button (click) = "hideTrackAttendeeForm(false)"><mat-icon>close</mat-icon></button>
                </div>
        </div>
        <table mat-table [dataSource]="dataSource" class="col-12 mat-elevation-z2 demo-table">
            <!-- Attendee Column -->
            <ng-container matColumnDef="attendeeName">
                <th mat-header-cell *matHeaderCellDef class="col-md-3 header-container">Attendee</th>
                <td mat-cell *matCellDef="let element">
                    <span id = "attendee{{element._id}}">{{element.attendeeName}}</span>
                    <span id = "edit-attendee{{element._id}}" [ngStyle]="{'display':'none'}">{{element.attendeeName}}</span>
                    <!-- <mat-form-field id = "edit-attendee{{element._id}}" [ngStyle]="{'display':'none'}">
                      <mat-select disableOptionCentering panelClass="common-drop-down-class" [value]="element.attendeeName" [disabled]="true">
                        <mat-option value = "element.attendeeName">
                          {{element.attendeeName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field> -->
                </td>
              </ng-container>
            
            <!-- Agenda Column -->
            <ng-container matColumnDef="agendaTitle">
              <th mat-header-cell *matHeaderCellDef class="col-md-2 header-container">Agenda</th>
              <td mat-cell *matCellDef="let element">
                  <span id = "agenda{{element._id}}">{{element.agendaTitle}}</span>
                  <mat-form-field id = "edit-agenda{{element._id}}" [ngStyle]="{'display':'none'}">
                    <mat-select disableOptionCentering panelClass="common-drop-down-class" [(ngModel)]="agendaTitle" >
                      <mat-option *ngFor="let m of agendaList" [value]="m.agendaTitle">{{m.agendaTitle}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </td>
            </ng-container>
          
            <!-- Time Column -->
            <ng-container matColumnDef="logTime">
              <th mat-header-cell *matHeaderCellDef class="col-md-2 header-container">Time</th>
              <td mat-cell *matCellDef="let element">{{element.logTime}}</td>
            </ng-container>
          
            <!-- Type Column -->
            <ng-container matColumnDef="logType">
              <th mat-header-cell *matHeaderCellDef class="col-md-2 header-container">Type</th>
              <td mat-cell *matCellDef="let element">{{element.logType}}</td>
            </ng-container>

            <!-- Reason Column -->
            <ng-container matColumnDef="reason">
                <th mat-header-cell *matHeaderCellDef class="col-md-3 header-container">Reason</th>
                <td mat-cell *matCellDef="let element">
                    <span id = "reason{{element._id}}">{{element.reason}}</span>
                    <mat-form-field id = "edit-reason{{element._id}}" [ngStyle]="{'display':'none'}">
                        <textarea matInput [(ngModel)]="editedReason" [ngStyle]="{'height':'23px'}"></textarea>
                    </mat-form-field>
                </td>
            </ng-container>
          
            <!-- Action Column -->
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="col-md-1 header-container">Action</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button id = "icon{{element._id}}" (click) = "triggerEditAttendee(element)"><mat-icon>edit</mat-icon></button>
                    <div class="action-content">
                        <button mat-icon-button class="table-action" id = "edit-icon-save{{element._id}}" [ngStyle]="{'display':'none'}" (click) = "saveEdit(element._id)"><mat-icon>save</mat-icon></button>
                        <button mat-icon-button id = "edit-icon-close{{element._id}}" [ngStyle]="{'display':'none'}" (click) = "cancelEdit(element._id)"><mat-icon>close</mat-icon></button>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
    </div>
    <mat-paginator actions [pageSizeOptions]="[10, 20]" [pageSize]="10"
                 showFirstLastButtons 
                 aria-label="Select page of periodic elements">
    </mat-paginator>
    <!-- <button mat-raised-button class="primary" [ngStyle]="{'color':'white'}" actions>SAVE</button>
    <button mat-raised-button class="primary" [ngStyle]="{'color':'white'}" actions>CANCEL</button> -->
</app-centre-small-opener>